{
  "name": "eneza-web-client",
  "version": "1.3.5",
  "engines": {
    "node": ">=22.22.3 || ^24.15.0 || >=26.0.0",
    "npm": "^6.11.0 || ^7.5.6 || >=8.0.0",
    "yarn": ">= 1.13.0"
  },
  "license": "UNLICENSED",
  "private": true,
  "scripts": {
    "ng": "ng",
    "build": "npm run build:shared && ng build client",
    "build:dev": "npm run build:shared:dev && ng build client --aot --configuration development",
    "build:prod": "npm run build:shared && ng build client --aot --configuration production",
    "build:waitrose:dev": "npm run build:shared:dev && ng build waitrose --aot --configuration development",
    "build:waitrose:prod": "npm run build:shared && ng build waitrose --aot --configuration production",
    "build:admin": "npm run build:shared:dev && ng build admin --aot --configuration development",
    "build:admin:dev": "npm run build:shared:dev && ng build admin --aot --configuration development",
    "build:admin:prod": "npm run build:shared && ng build admin --aot --configuration production",
    "build:shared": "ng build shared",
    "build:shared:dev": "ng build shared --configuration development",
    "deploy:admin:dev": "firebase deploy --only hosting:admin -P dev",
    "deploy:admin:prod": "firebase deploy --only hosting:admin -P prod",
    "deploy": "firebase deploy",
    "deploy:dev": "firebase deploy -P dev",
    "deploy:prod": "firebase deploy -P prod",
    "deploy:beta": "firebase deploy --only hosting:beta -P prod",
    "deploy:client:dev": "firebase deploy --only hosting:client -P dev",
    "deploy:client:prod": "firebase deploy --only hosting:client -P prod",
    "deploy:waitrose:dev": "firebase deploy --only hosting:waitrose -P dev",
    "deploy:waitrose:prod": "firebase deploy --only hosting:waitrose -P prod",
    "start": "npm run build:shared:dev && ng s client",
    "start:prod": "npm run build:shared && ng s client --configuration production",
    "start:waitrose": "npm run build:shared:dev && ng s waitrose",
    "start:admin": "npm run build:shared:dev && ng s admin",
    "prepare": "husky",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "ng lint client",
    "lint:fix": "ng lint client --fix",
    "lint:admin": "ng lint admin",
    "lint:admin:fix": "ng lint admin --fix",
    "lint:shared": "ng lint shared",
    "lint:shared:fix": "ng lint shared --fix",
    "lint:fix:all": "npm run build:shared:dev && npm run lint:fix && npm run lint:admin:fix && npm run lint:shared:fix && npm run format",
    "lint:fix:changed": "node -e \"const {execSync}=require('node:child_process'); const files=execSync('git diff --name-only --diff-filter=ACMR',{encoding:'utf8'}).trim().split('\\n').filter(Boolean); const prettierFiles=files.filter(f=>/\\.(ts|html|css|scss|json|md|yml|yaml)$/.test(f)); if(prettierFiles.length){execSync('npx prettier --write '+prettierFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No changed files for Prettier.');} const lintFiles=files.filter(f=>/\\.(ts|html)$/.test(f)); if(lintFiles.length){execSync('npx eslint --fix '+lintFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No changed TS/HTML files for ESLint.');}\"",
    "lint:fix:staged": "node -e \"const {execSync}=require('node:child_process'); const files=execSync('git diff --cached --name-only --diff-filter=ACMR',{encoding:'utf8'}).trim().split('\\n').filter(Boolean); const prettierFiles=files.filter(f=>/\\.(ts|html|css|scss|json|md|yml|yaml)$/.test(f)); if(prettierFiles.length){execSync('npx prettier --write '+prettierFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No staged files for Prettier.');} const lintFiles=files.filter(f=>/\\.(ts|html)$/.test(f)); if(lintFiles.length){execSync('npx eslint --fix '+lintFiles.map(f=>JSON.stringify(f)).join(' '),{stdio:'inherit'});} else {console.log('No staged TS/HTML files for ESLint.');}\"",
    "check:no-feature-settitle": "node scripts/check-no-feature-settitle.cjs",
    "check:param-route-title-tokens": "node scripts/check-param-route-title-tokens.cjs",
    "check:param-route-title-tokens:test": "node --test scripts/check-param-route-title-tokens.test.cjs",
    "check:no-angular-material": "node scripts/check-no-angular-material.cjs",
    "check:no-angular-material:test": "node --test scripts/check-no-angular-material.test.cjs",
    "check:no-cross-app-imports": "node scripts/check-no-cross-app-imports.cjs",
    "check:no-cross-app-imports:test": "node --test scripts/check-no-cross-app-imports.test.cjs",
    "ci:route-title-guard": "npm run check:no-feature-settitle && npm run check:param-route-title-tokens",
    "ci:no-angular-material": "npm run check:no-angular-material",
    "ci:no-cross-app-imports": "npm run check:no-cross-app-imports",
    "ci:guards": "npm run ci:route-title-guard && npm run ci:no-angular-material && npm run ci:no-cross-app-imports",
    "ci:missing-specs": "node scripts/list-missing-specs.cjs --kind=all --fail",
    "ci:unit-tests": "npm run test:ci && npm run test:shared && npm run ci:missing-specs",
    "test": "ng test client",
    "test:admin": "npm run build:shared:dev && ng test admin --watch=false",
    "test:shared": "ng test shared --watch=false",
    "test:ci": "npm run build:shared:dev && NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false",
    "test:ci:emulators": "npm run build:shared:dev && NODE_OPTIONS=--max-old-space-size=3072 FIREBASE_TEST_MODE=emulator ng test client --watch=false",
    "test:coverage": "npm run build:shared:dev && NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false --coverage --coverage-reporters=text-summary",
    "test:coverage:gate": "npm run build:shared:dev && mkdir -p coverage/client/.tmp && NODE_OPTIONS=--max-old-space-size=3072 ng test client --watch=false --configuration=coverage-gate",
    "check:missing-specs": "node scripts/list-missing-specs.cjs"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{css,scss,json,md,yml,yaml}": [
      "prettier --write"
    ]
  },
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "^22.2.6",
    "@angular/common": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/google-maps": "^22.2.6",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@enezatelecoms/eneza-models": "^1.9.8",
    "@enezatelecoms/node-financejs": "^0.1.1",
    "@ng-select/ng-select": "^23.11.0",
    "@ngneat/dialog": "^5.2.1",
    "@ngneat/overview": "^8.1.0",
    "@ngxpert/hot-toast": "^7.0.0",
    "@stripe/stripe-js": "^10.2.1",
    "core-js": "^3.51.0",
    "creditcard.js": "^3.0.64",
    "csvtojson": "^2.0.14",
    "expr-eval": "^2.0.2",
    "file-saver": "^2.0.5",
    "firebase": "^12.19.0",
    "google-libphonenumber": "^3.2.48",
    "highcharts": "^13.1.1",
    "highcharts-angular": "^5.4.1",
    "js-md5": "^0.9.2",
    "jszip": "^3.10.2",
    "moment": "^2.31.0",
    "ngx-chips": "^3.0.0",
    "ngx-editor": "^19.1.1",
    "pdfmake": "^0.3.13",
    "rxfire": "^6.3.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.9.1",
    "uuid": "^14.0.3",
    "xlsx": "^0.18.5",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2202.5",
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler": "^22.2.4",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@eslint/js": "^10.0.1",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/postcss": "^4.3.4",
    "@types/file-saver": "^2.0.7",
    "@types/pdfmake": "^0.3.3",
    "@vitest/coverage-v8": "^5.1.0",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.14.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.7",
    "first-input-delay": "^0.1.3",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "ng-packagr": "^22.2.6",
    "open": "^11.0.4",
    "postcss": "^8.5.29",
    "prettier": "^3.9.10",
    "prettier-eslint": "^17.1.2",
    "prettier-plugin-organize-imports": "^4.3.0",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^4.3.4",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.1",
    "vitest": "^5.1.0"
  }
}
